$(document).ready(function () {
  /// Main search input
  $('#pageheader .search-box input[type="text"]').bind('focusin focusout', function (e) {
    $(this)
      .closest('.search-box')
      .toggleClass('focus', e.type == 'focusin')
  })

  /// Live search
  var searchTimeoutThrottle = 500
  var searchTimeoutID = -1
  var currReqObj = null
  var $resultsBox = $('<div class="results-box" />').appendTo('#search-recp')
  $('#pageheader .search-box input[type="text"]')
    .bind('keyup change', function () {

      //Only search if search string longer than 2, and it has changed
      console.log("live search enabled:", Alpine.store("meilimetaNew").enabled);
      if (($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) || Alpine.store("meilimetaNew").enabled) {
        console.log("live search for:", $(this).val())
        //Reset previous value
        $(this).data('oldval', $(this).val())

        // Kill outstanding ajax request
        if (currReqObj != null) currReqObj.abort()

        // Kill previous search
        clearTimeout(searchTimeoutID)

        var $form = $(this).closest('form')

        //Search term
        var term = '*' + $form.find('input[name="q"]').val() + '*'

        //URL for full search page
        var linkURL = $form.attr('action') + '?type=product&q=' + term

        //Show loading
        $resultsBox.html('<div class="load"></div>')

        // Do next search (in X milliseconds)
        searchTimeoutID = setTimeout(function () {
          //Ajax hit on search page
          currReqObj = $.ajax({
            url: $form.attr('action'),
            data: {
              type: 'article',
              view: 'json',
              q: term,
            },
            dataType: 'json',
            success: function (data) {
              currReqObj = null
              if (data.results_total == 0) {
                //No results
                $resultsBox.html(
                  '<div class="note">' + 'translation missing: de.layout.live_search.no_results' + '</div>'
                )
              } else {
                //Numerous results
                $resultsBox.empty()

                $resultsBox.append(
                  '<div class="container"><div class="ArticleListWrapper" >\n' +
                  '                  <div class="ArticleList Grid Grid--m Grid--center ajax-search-rec" > </div></div></div>'
                )

                $.each(data.results, function (index, item) {
                  var xshow = 'wholesale' //term for products we dont want to show
                  if (!(item.title.toLowerCase().indexOf(xshow) > -1)) {
                    var $row = $(
                      '<div class="Grid__Cell 1/2--tablet 1/3--lap-and-up ">\n' +
                      '    <article class="ArticleItem">\n' +
                      '<a class="ArticleItem__ImageWrapper AspectRatio AspectRatio--withFallback" style="background: url(' +
                      item.thumb +
                      '); padding-bottom: 58%; --aspect-ratio: 1.7" href="' +
                      item.url +
                      '">\n' +
                      '<img src="' +
                      item.thumb +
                      '" />' +
                      '\n' +
                      '</a>\n' +
                      ' <div class="ArticleItem__Content Text--alignCenter"><div class="ArticleItem__Title Heading u-h2">\n' +
                      '    <a href="' +
                      item.url +
                      '">' +
                      item.title +
                      '</a>\n' +
                      '</div>\n' +
                      '     <p class="ArticleItem__Excerpt">&nbsp;</p>\n' +
                      '    <a href="' +
                      item.url +
                      '" class="ArticleItem__Link Button Button--secondary">Mehr lesen</a></div>\n' +
                      '</article>'
                    )

                    $('.ajax-search-rec').append($row)
                  }
                })

                $resultsBox.append('<a href="' + linkURL + '" class="note">See All </a>')
              }
            },
          })
        }, searchTimeoutThrottle)
      } else if ($(this).val().length <= 2) {
        //Deleted text? Clear results
        $resultsBox.empty()
      }
    })
    .attr('autocomplete', 'off')
    .data('oldval', '')
    .bind('focusin', function () {
      //Focus, show results
      $resultsBox.fadeIn(200)
    })
    .bind('click', function (e) {
      //Click, prevent body from receiving click event
      e.stopPropagation()
    })
  $('body').bind('click', function () {
    //Click anywhere on page, hide results
    $resultsBox.fadeOut(200)
  })

  //Search box should mimic live search string: products only, partial match
  $('.search-form, #search-form').on('submit', function (e) {
    e.preventDefault()
    var term = '*' + $(this).find('input[name="q"]').val() + '*'
    var linkURL = $(this).attr('action') + '?type=article&q=' + term
    window.location = linkURL
  })

  // search ends
})
